import $ from 'jquery'
import { 
    cookieNames,
    removeAfterCheckoutRedirection,
    getAfterLoginRedirection,
    removeAfterLoginRedirection,
    removeSkipAfterCheckoutOnboard,
    protectedApiCall,
    sentryAPIErrorV2,
    showSpinner,
    checkoutLink,
    websiteUrl,
    sentryAPIInfo,
} from './module_common';

import {
    firebaseSetLanguageCode, 
    firebaseGetCurrentUser,
    firebaseSendVerificationEmail,
    firebaseOnAuthStateChanged,
} from './module_firebase';

import { openModal } from './module_modal';

import Cookies from 'js-cookie'

let redirectToProfileOnProblemSendingEmailModalClose = true
let showVerifyEmailPopup = true
// site path the verification link leads to, null = the current page
let verificationEmailPath = null

export function setVerificationEmailPath(path){
    verificationEmailPath = path
}

function sendVerificationEmail_send(user, uid, code, ntm){
    const path = verificationEmailPath || window.location.pathname
    const sep = path.includes('?') ? '&' : '?'
    const verificationUrl = window.location.origin + path + sep + 'uid=' + uid + '&vc=' + code
    //Redirects after verification
    const actionCodeSettings = {
        url: verificationUrl
    };
    // user.sendEmailVerification(actionCodeSettings)
    firebaseSendVerificationEmail(user, actionCodeSettings)
        .then(function () {
            if (showVerifyEmailPopup){
                document.getElementById("verifyEmailModal").addEventListener("hidden.bs.modal", function(){
                    document.body.dispatchEvent(new CustomEvent("emailVerificationFlowDone"))
                    if (ntm) needToMove(true);
                })
                openModal('#verifyEmailModal', 'sendVerificationEmail_send')
            }else{
                if (ntm) needToMove(true);
            }
        })
        .catch(function (err) {
            const contextData = {
                apicalldata:{
                    function: "sendVerificationEmail_send",
                    status: err.status,
                    response: err.responseJSON,
                    uid: UIDg,
                }
            }
            const error = new Error('Error sendind verification email')
            error.name = 'sendVerificationEmail_send fail'
            sentryAPIErrorV2(error, contextData)
            document.getElementById('problemSendingEmailModal').addEventListener("hidden.bs.modal", function(){
                document.body.dispatchEvent(new CustomEvent("emailVerificationFlowDone"))
                if (!redirectToProfileOnProblemSendingEmailModalClose) return
                window.location.href = '/' + LL + '/profilo';
            })
            openModal('#problemSendingEmailModal', 'sendVerificationEmail_send')
        });
}

export function doNotRedirectToProfileOnProblemSendingEmailModalClose(){
    redirectToProfileOnProblemSendingEmailModalClose = false
}

export function needToMove(reload) {
    reload = reload || false;
    const url = getAfterLoginRedirection();
    if (url) {
        showSpinner();
        removeAfterLoginRedirection()
        sessionStorage.setItem('mustReloadOnBack', location.href)
        window.location.href = url;
    } else {
        if (reload) {
            showSpinner();
            location.reload();
        }
    }
}

export function cleanCheckoutSetting() {
    removeAfterCheckoutRedirection()
    removeSkipAfterCheckoutOnboard()
}

export function openResendEmail(uid, verifycode, ntm){
    $("#resendemail").on("click", function(){
        sendVerificationEmail(uid, verifycode, ntm);
    })
    openModal("#resendEmailModal", "openResendEmail")
}

export function reVerifyEmailAndOpenResendPopup(planRequested){
    protectedApiCall(
        'GET', 
        '/users/' + UIDg + '?preventCache=' + new Date(), 
        null,
        function (resp) {
            const user = resp['user']
            if (user) {
                const { user_verified: userVerified, verified: emailVerified } = user;
                if (userVerified) {
                    redirectToCheckoutPage(planRequested);
                } else if (!emailVerified){
                    cleanCheckoutSetting();
                    openResendEmail(UIDg, resp['user']['vc'], false)
                }else{
                    // user not verified, email verified
                    // edge case, shoul not be present....
                    // go to checkout and send to Sentry
                    const contextData = {
                        datas:{
                            function: "reVerifyEmailAndOpenResendPopup",
                            uid: user.id,
                        }
                    }
                    const error = new Error('Inconsistent user')
                    error.name = 'User not verified, email verified'
                    sentryAPIErrorV2(error, contextData)
                    redirectToCheckoutPage(planRequested);
                }
            } else {
                cleanCheckoutSetting();
                openModal("#requestProblemTryLogoutModal", "reVerifyEmailAndOpenResendPopup")
            }
        },
        function (err) {
            cleanCheckoutSetting();
            openModal("#requestProblemTryLogoutModal", "reVerifyEmailAndOpenResendPopup")
        });
}

export function redirectToCheckoutPage(plan){
    const queryString = allPlans[plan]['chkQueryString']
    const jwt = new URLSearchParams(queryString).get('p')
    preCheckoutActions(jwt)
    window.location.href = `${checkoutLink}${queryString}`
}

function sendCheckoutBtnClickedMessage(checkoutJwt){
    const contextData = {
        datas:{
            pgUrl: window.location.href,
            chkJwt: checkoutJwt,
            Uid: UIDg
        }
    }
    sentryAPIInfo('Checkout button clicked V2', contextData, ['chk-btn-click'])
}

export function preCheckoutActions(checkoutJwt){
    // sendCheckoutBtnClickedMessage(checkoutJwt)

    // pushDataLayerData()   
    // TODO
    // check if the functions below are really needed
    Cookies.remove(cookieNames.guestSubscribing); // check where is used 
    
    // ---- redirect url set in php ----
    // ---------------------------------
    // const thankyoupageUrl = getThankyoupageUrl() 
    // if (thankyoupageUrl !== ""){
    //     setSkipAfterCheckoutOnboard()
    //     setAfterCheckoutRedirection(thankyoupageUrl)
    // }
}

export function sendVerificationEmail(uid, code, ntm = false) {
    firebaseSetLanguageCode(LL)
    let user = firebaseGetCurrentUser();
    if (user){
        sendVerificationEmail_send(user, uid, code, ntm);
    }else{
        const unsubscribeFromStateChange = firebaseOnAuthStateChanged((user)=>{
            if (user) {
                sendVerificationEmail_send(user, uid, code, ntm);
                // detach the listener
                unsubscribeFromStateChange();
            }
        })
    }
}

// used for offer page
export function getThankyoupageUrl(){
    const el = $('.goto-data')
    if (el.length){
        return el.data('goto')
    }
    return ""
}

export function setShowVerifyEmailPopup(value){
    showVerifyEmailPopup = value ? true : false
}

// does not indicate that the modal is currently open, but that it will be shown
export function isVerifyEmailPopupShown(){
    return showVerifyEmailPopup
}